module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedicationTextCenter"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This book is dedicated to my dear Óli.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationTextCenter"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Special thanks to Harald Schmitt,"), _c('br'), _vm._v(" who lent me his name—"), _c('br'), _vm._v(" and allowed me to kill him.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationAuthor"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("–Yrsa")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f23306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ded01.vue
// module id = 63
// module chunks = 0